import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Container, Stack } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";

const images = [
  "https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1600&q=80",
  "https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&w=1600&q=80",
];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  // Auto change every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: { xs: "80vh", md: "95vh" },
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        color: "#fff",
      }}
    >
      {/* Background Slider */}
      <AnimatePresence>
        <motion.div
          key={index}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${images[index]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
          }}
        />
      </AnimatePresence>

      {/* Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.3))",
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Box maxWidth="650px">

          {/* Tag */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Typography
              sx={{
                mb: 2,
                px: 2,
                py: 0.5,
                display: "inline-block",
                background: "rgba(255,255,255,0.15)",
                borderRadius: "20px",
                backdropFilter: "blur(6px)",
                fontSize: "0.85rem",
              }}
            >
              Trusted by 500+ Institutions
            </Typography>
          </motion.div>

          {/* Heading */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Typography
              variant="h2"
              fontWeight="bold"
              sx={{
                fontSize: { xs: "2rem", md: "3rem" },
                mb: 2,
              }}
            >
              Upgrade Your Institution
            </Typography>
          </motion.div>

          {/* Subtext */}
          <motion.div
            initial={{ opacity: 0, y: 70 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 4, color: "rgba(255,255,255,0.85)" }}
            >
              Discover furniture, lab equipment, IT devices and more.
            </Typography>
          </motion.div>

          {/* Buttons */}
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              size="large"
              sx={{
                px: 4,
                background: "#0054CB",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              Shop Now
            </Button>

            <Button
              variant="outlined"
              size="large"
              sx={{
                color: "#fff",
                borderColor: "#fff",
              }}
            >
              Explore
            </Button>
          </Stack>

        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;